import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancel-inv',
  templateUrl: './cancel-inv.component.html',
  styleUrls: ['./cancel-inv.component.scss']
})
export class CancelInvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
